// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-27T06:56:37Z                      #

// ##############################################################

// @ts-ignore - not used import
import {AxiosInstance, AxiosResponse, AxiosRequestConfig, CancelToken} from 'axios';
// @ts-ignore - not used import
import {unwrapResponse, generateUrl, baseAxios} from '@mc/axios-api';
// @ts-ignore - not used import
import * as importUrl from 'url';
// @ts-ignore - not used import
import TempDocumentVO from "./types/TempDocumentVO";

// @ts-ignore - not used import
import * as UpdateMethods from "./UpdateMethods";


// @ts-ignore - not used import
type SimpleHeaders = {[key: string]: string};

/**
 * Controller pro upload souborů Generated from cz.marbes.qsign.controller.FileUploadController.
 */
export default class FileUploadApi {
    /**
     * Smaže dočasné soubory dle předané množiny identifikátorů
     *
     * @param uuidList množina identifikátorů
     */
    static deleteDocuments(uuidList : string[], config?: {cancelToken?: CancelToken}) {
        return unwrapResponse<any>(FileUploadApi.raw.deleteDocuments(uuidList, config));
    }
    /**
     * Dočasně uloží dokument pro hromadné podepsání po asynchronním uploadu. vrátí identifikátor dokumentů pro budoucí hromadné zpracování
     *
     * @param file 
     * @param fileName 
     * @return identifikátor nahraného dokumentu
     */
    static uploadDocument(file : Blob, fileName : string, config?: {cancelToken?: CancelToken}) : Promise<TempDocumentVO> {
        return unwrapResponse<TempDocumentVO>(FileUploadApi.raw.uploadDocument(file, fileName, config));
    }

    static raw = {
            deleteDocuments: function(uuidList : string[], config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<any>> {
                const uri = `/qsign/api/file/temp/delete`;
                const headers : SimpleHeaders = {};
                headers['Content-Type'] = 'application/json';

                const params = {  };
                 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, any>(finalUri, uuidList, finalConfig);
            },
            uploadDocument: function(file : Blob, fileName : string, config?: AxiosRequestConfig, axiosInstance: AxiosInstance = baseAxios): Promise<AxiosResponse<TempDocumentVO>> {
                const uri = `/qsign/api/file/temp`;
                const headers : SimpleHeaders = {};
                headers["Content-Type"] = "multipart/form-data";
                const params = {  };
                const data = new FormData();
                if (file != null) {data.append("file", file);}
if (fileName != null) {data.append("fileName", fileName);}
 

                const finalUri = params && Object.keys(params).length > 0 ? uri + importUrl.format({query: params}) : uri;

                let finalHeaders;
                if (config && config.headers) {
                    finalHeaders = {
                        ...(headers || {}),
                        ...config.headers
                    };
                } else {
                    finalHeaders = headers;
                }

                const finalConfig = {
                    ...config,
                    headers: finalHeaders
                }


                return axiosInstance.post<any, AxiosResponse<TempDocumentVO>>(finalUri, data, finalConfig);
            },
    }
}
